export default __webpack_public_path__ + "locales/it/EmptyView.json?hash=c7dc467c03e84337edc52ee4f733daa3";